import { TestTypeProducts } from '@probatix/common/services/toolkit/product/productService.model'
import { GeoData } from '@probatix/common/services/RTKServices/locations/index.model'
import { Product } from './checkoutStepsService.model'

const url = `${process.env.VITE_CORE_API_ENTRYPOINT}/api/v0/checkout/`
export const basePathOfProductList = `${url}products`
export const basePathOfProduct = `${url}product`

export const selectProductsByLocation = (products: any[], location: GeoData) => {
  const { availableProductTypes } = location
  const testTypeProducts: TestTypeProducts[] = []

  if (availableProductTypes) {
    Object.entries(availableProductTypes).forEach((entry: [string, string[]]) => {
      const testTypeProduct: TestTypeProducts = { id: entry[0], products: [], testType: entry[0] }
      const productsUuid = entry[1]

      Object.values(productsUuid).forEach((uuid) => {
        if (!products?.length) {
          return
        }

        const product = products.find((p) => p.uuid === uuid)
        if (product) {
          if (product.isShowProductOnFrontend) {
            testTypeProduct.products.push(product)
          }
        }
      })

      if (testTypeProduct.products.length) {
        const sortedProducts = testTypeProduct.products.sort((a, b) => a.grossPrice - b.grossPrice)

        testTypeProducts.push({
          ...testTypeProduct,
          products: sortedProducts,
        })
      }
    })

    return testTypeProducts
  }

  return products
}

export const findProduct = (products: Product[], uuid: string) => products.find((p) => {
  if ('default' === uuid) {
    return p.isShowProductOnFrontend
  }

  return p.uuid === uuid
})
